import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualSwiperComponent } from './virtual-swiper.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SwiperSlideDirective, SwiperSlideTemplateDirective } from './virtual-swiper-model';

@NgModule({
    declarations: [VirtualSwiperComponent, SwiperSlideDirective, SwiperSlideTemplateDirective],
    imports: [
        CommonModule,
        ScrollingModule
    ],
    exports: [VirtualSwiperComponent, SwiperSlideDirective, SwiperSlideTemplateDirective]
})
export class VirtualSwiperModule { }
